import guenoApi from '../../services/guenoApi'

const kycv2Api = guenoApi.injectEndpoints({
  endpoints: (builder) => ({
    // Persons endpoints
    findKycV2Persons: builder.query({
      query: ({ limit, page, text, status }) => {
        return {
          url: '/kycV2/persons',
          params: {
            limit,
            page,
            text,
            status,
          },
        }
      },
      providesTags: ['kycv2PersonList'],
    }),
    createKycV2Person: builder.mutation({
      query: ({ body }) => ({
        url: `/kycV2/person`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['kycv2PersonList'],
    }),
    getKycV2Person: builder.query({
      query: ({ id }) => {
        return {
          url: `/kycV2/person/${id}`,
        }
      },
      providesTags: ['kycv2Person'],
    }),
    updateKycV2Person: builder.mutation({
      query: ({ id, body }) => ({
        url: `/kycV2/person/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['kycv2Person', 'kycv2PersonList'],
    }),
    updateKycV2PersonStatus: builder.mutation({
      query: ({ id, body }) => ({
        url: `/kycV2/person/${id}/status`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['kycv2Person', 'kycv2PersonList'],
    }),
    deleteKycV2Person: builder.mutation({
      query: ({ id }) => ({
        url: `/kycV2/person/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['kycv2PersonList'],
    }),

    // Sessions endpoints
    createKycV2Session: builder.mutation({
      query: ({ personId, body }) => ({
        url: `/kycV2/person/${personId}/session`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['kycv2PersonSessions', 'kycv2Person'],
    }),
    getKycV2PersonSessions: builder.query({
      query: ({ personId }) => {
        return {
          url: `/kycV2/person/${personId}/sessions`,
        }
      },
      providesTags: ['kycv2PersonSessions'],
    }),
    getKycV2Session: builder.query({
      query: ({ sessionId }) => {
        return {
          url: `/kycV2/session/${sessionId}`,
        }
      },
      providesTags: ['kycv2Session'],
    }),
    syncKycV2Session: builder.mutation({
      query: ({ sessionId }) => ({
        url: `/kycV2/session/${sessionId}/sync`,
        method: 'POST',
      }),
      invalidatesTags: ['kycv2Session', 'kycv2PersonSessions', 'kycv2Person'],
    }),
    downloadKycV2SessionPdf: builder.query({
      query: ({ sessionId }) => {
        return {
          url: `/kycV2/session/${sessionId}/pdf`,
          responseHandler: (response) => response.blob(),
        }
      },
    }),
  }),
})

export const {
  useFindKycV2PersonsQuery,
  useCreateKycV2PersonMutation,
  useGetKycV2PersonQuery,
  useUpdateKycV2PersonMutation,
  useUpdateKycV2PersonStatusMutation,
  useDeleteKycV2PersonMutation,
  useCreateKycV2SessionMutation,
  useGetKycV2PersonSessionsQuery,
  useGetKycV2SessionQuery,
  useSyncKycV2SessionMutation,
  useLazyDownloadKycV2SessionPdfQuery,
} = kycv2Api
